import { z } from "zod/v4";

export const TerminalStatusSchema = z.enum(["idle", "spawning", "running", "exited"]);
export type TerminalStatus = z.infer<typeof TerminalStatusSchema>;

export type TerminalInstanceKey = {
	documentId: string;
	terminalId: string;
};

export type TerminalState = {
	status: TerminalStatus;
	pid: number | null;
	exitCode: number | null;
};

export const initialTerminalState: TerminalState = {
	status: "idle",
	pid: null,
	exitCode: null,
};

export type TerminalSpawnOptions = {
	command?: string;
	args?: string[];
	cwd?: string;
	env?: Record<string, string>;
	cols?: number;
	rows?: number;
};

export type ScriptOutput = {
	status: number | null;
	stdout: Uint8Array;
	stderr: Uint8Array;
};
